import React from "react";

export const HelpContext = React.createContext(null)